import { GenericOperationState } from '@repo/core'
import { ExternalToolLinkResponse } from '@repo/tools-types'
import { RootState } from '../../store/types'

export const externalToolLinkDataSelectorConfig = {
  externalToolLinkDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ExternalToolLinkResponse | null> {
      return state.tools.external.link
    },
  },
}
